<template>
  <div>
    <b-card-code title="Selecciona el tipo de ingreso">
      <b-row>
        <b-col md="6">
          <b-form-input id="joining_type" v-model="selected.joining_type" disabled />
        </b-col>
        <b-col md="6">
          <div>
            <b-button variant="dark" @click="$router.go(-1)">
              <feather-icon icon="ArrowLeftIcon" class="mr-50" />
              <span class="align-middle">Atrás</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card-code>
    <b-card-code title="Ingrese los datos del puesto">
      <b-row>
        <b-col md="4">
          <b-col>
            <b-form-group label="Año Presupuesto" label-for="budget_year">
              <b-form-input id="budget_year" v-model="selected.budget_year" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Código Presupuesto" label-for="budget_code">
              <b-form-input id="budget_code" v-model="selected.budget_code" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Tipo de Planilla" label-for="payroll_type">
              <b-form-input id="payroll_type" v-model="selected.payroll_type" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Empresa" label-for="company">
              <b-form-input id="company" v-model="selected.company" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Puesto" label-for="position">
              <b-form-input id="position" v-model="selected.position" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Departamento" label-for="department">
              <b-form-input id="department" v-model="selected.department" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Área" label-for="area">
              <b-form-input id="area" v-model="selected.area" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Sección" label-for="section">
              <b-form-input id="section" v-model="selected.section" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Código Ceco" label-for="ceco_code">
              <b-form-input id="ceco_code" v-model="selected.ceco_code" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Tipo de Ceco" label-for="ceco_type">
              <b-form-input id="ceco_type" v-model="selected.ceco_type" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Subdivision" label-for="subdivision">
              <b-form-input id="subdivision" v-model="selected.subdivision" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Tipo de Labor" label-for="labor_type">
              <b-form-input id="labor_type" v-model="selected.labor_type" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Estado" label-for="status">
              <b-form-input id="status" v-model="selected.status" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="No. de Organigrama" label-for="organization_chart_id">
              <b-form-input id="organization_chart_id" v-model="selected.organization_chart_id" disabled />
            </b-form-group>
          </b-col>
        </b-col>
        <b-col md="4">
          <b-col>
            <b-form-group label="SAP Código Trabajador" label-for="sap_doc_num">
              <b-form-input id="sap_doc_num" v-model="selected.sap_code" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Número de Documento" label-for="sap_doc_num">
              <b-form-input id="sap_doc_num" v-model="selected.sap_doc_num" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Nombres y Apellidos" label-for="sap_full_name">
              <b-form-input id="sap_full_name" v-model="selected.sap_full_name" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Puesto" label-for="sap_position">
              <b-form-input id="sap_position" v-model="selected.sap_position" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Código Ceco" label-for="sap_ceco_code">
              <b-form-input id="sap_ceco_code" v-model="selected.sap_ceco_code" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Descripcion Ceco" label-for="sap_ceco_description">
              <b-form-input id="sap_ceco_description" v-model="selected.sap_ceco_description" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Descripcion Área" label-for="sap_area_description">
              <b-form-input id="sap_area_description" v-model="selected.sap_area_description" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Departamento" label-for="sap_department">
              <b-form-input id="sap_department" v-model="selected.sap_department" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Área" label-for="sap_area">
              <b-form-input id="sap_area" v-model="selected.sap_area" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Sección" label-for="sap_section">
              <b-form-input id="sap_section" v-model="selected.sap_section" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Periodo de Aplicación" label-for="application_period">
              <b-form-input id="application_period" v-model="selected.application_period" disabled />
            </b-form-group>
          </b-col>
        </b-col>
        <b-col md="4">
          <b-col>
            <b-form-group label="Código de Presupuesto - Reporte Jerarquico" label-for="budget_code_1">
              <b-form-input id="budget_code_1" v-model="selected.budget_code_1" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Código Trabajador - Reporte Jerarquico" label-for="budget_code_1_sap_code">
              <b-form-input id="budget_code_1_sap_code" v-model="selected.budget_code_1_sap_code" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Número de Documento - Reporte Jerarquico" label-for="budget_code_1_num_doc">
              <b-form-input id="budget_code_1_num_doc" v-model="selected.budget_code_1_num_doc" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Nombres y Apellidos - Reporte Jerarquico" label-for="budget_code_1_full_name">
              <b-form-input id="budget_code_1_full_name" v-model="selected.budget_code_1_full_name" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Código de Presupuesto - Reporte Funcional" label-for="budget_code_2">
              <b-form-input id="budget_code_2" v-model="selected.budget_code_2" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="SAP Código Trabajador - Reporte Funcional" label-for="budget_code_2_sap_code">
              <b-form-input id="budget_code_2_sap_code" v-model="selected.budget_code_2_sap_code" disabled />
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label="SAP Número de Documento - Reporte Funcional" label-for="budget_code_2_num_doc">
              <b-form-input id="budget_code_2_num_doc" v-model="selected.budget_code_2_num_doc" disabled />
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label="SAP Nombres y Apellidos - Reporte Funcional" label-for="budget_code_2_full_name">
              <b-form-input id="budget_code_2_full_name" v-model="selected.budget_code_2_full_name" disabled />
            </b-form-group>
          </b-col>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Semanas" label-for="weeks">
            <div style="overflow-x:auto;">
              <table class="table">
                <thead>
                  <tr>
                    <td>ENERO</td>
                    <td>ENERO</td>
                    <td>ENERO</td>
                    <td>ENERO</td>
                    <td>ENERO</td>
                    <td>FEBRERO</td>
                    <td>FEBRERO</td>
                    <td>FEBRERO</td>
                    <td>FEBRERO</td>
                    <td>MARZO</td>
                    <td>MARZO</td>
                    <td>MARZO</td>
                    <td>MARZO</td>
                    <td>ABRIL</td>
                    <td>ABRIL</td>
                    <td>ABRIL</td>
                    <td>ABRIL</td>
                    <td>MAYO</td>
                    <td>MAYO</td>
                    <td>MAYO</td>
                    <td>MAYO</td>
                    <td>JUNIO</td>
                    <td>JUNIO</td>
                    <td>JUNIO</td>
                    <td>JUNIO</td>
                    <td>JULIO</td>
                    <td>JULIO</td>
                    <td>JULIO</td>
                    <td>JULIO</td>
                    <td>JULIO</td>
                    <td>AGOSTO</td>
                    <td>AGOSTO</td>
                    <td>AGOSTO</td>
                    <td>AGOSTO</td>
                    <td>SEPTIEMBRE</td>
                    <td>SEPTIEMBRE</td>
                    <td>SEPTIEMBRE</td>
                    <td>SEPTIEMBRE</td>
                    <td>OCTUBRE</td>
                    <td>OCTUBRE</td>
                    <td>OCTUBRE</td>
                    <td>OCTUBRE</td>
                    <td>OCTUBRE</td>
                    <td>NOVIEMBRE</td>
                    <td>NOVIEMBRE</td>
                    <td>NOVIEMBRE</td>
                    <td>NOVIEMBRE</td>
                    <td>DICIEMBRE</td>
                    <td>DICIEMBRE</td>
                    <td>DICIEMBRE</td>
                    <td>DICIEMBRE</td>
                    <td>DICIEMBRE</td>
                  </tr>
                  <tr>
                    <td v-if="this.checkIfWeekIsGreater(1)" class="table-primary">SEM 1</td>
                    <td v-else>SEM 1</td>
                    <td v-if="this.checkIfWeekIsGreater(2)" class="table-primary">SEM 2</td>
                    <td v-else>SEM 2</td>
                    <td v-if="this.checkIfWeekIsGreater(3)" class="table-primary">SEM 3</td>
                    <td v-else>SEM 3</td>
                    <td v-if="this.checkIfWeekIsGreater(4)" class="table-primary">SEM 4</td>
                    <td v-else>SEM 4</td>
                    <td v-if="this.checkIfWeekIsGreater(5)" class="table-primary">SEM 5</td>
                    <td v-else>SEM 5</td>
                    <td v-if="this.checkIfWeekIsGreater(6)" class="table-primary">SEM 6</td>
                    <td v-else>SEM 6</td>
                    <td v-if="this.checkIfWeekIsGreater(7)" class="table-primary">SEM 7</td>
                    <td v-else>SEM 7</td>
                    <td v-if="this.checkIfWeekIsGreater(8)" class="table-primary">SEM 8</td>
                    <td v-else>SEM 8</td>
                    <td v-if="this.checkIfWeekIsGreater(9)" class="table-primary">SEM 9</td>
                    <td v-else>SEM 9</td>
                    <td v-if="this.checkIfWeekIsGreater(10)" class="table-primary">SEM 10</td>
                    <td v-else>SEM 10</td>
                    <td v-if="this.checkIfWeekIsGreater(11)" class="table-primary">SEM 11</td>
                    <td v-else>SEM 11</td>
                    <td v-if="this.checkIfWeekIsGreater(12)" class="table-primary">SEM 12</td>
                    <td v-else>SEM 12</td>
                    <td v-if="this.checkIfWeekIsGreater(13)" class="table-primary">SEM 13</td>
                    <td v-else>SEM 13</td>
                    <td v-if="this.checkIfWeekIsGreater(14)" class="table-primary">SEM 14</td>
                    <td v-else>SEM 14</td>
                    <td v-if="this.checkIfWeekIsGreater(15)" class="table-primary">SEM 15</td>
                    <td v-else>SEM 15</td>
                    <td v-if="this.checkIfWeekIsGreater(16)" class="table-primary">SEM 16</td>
                    <td v-else>SEM 16</td>
                    <td v-if="this.checkIfWeekIsGreater(17)" class="table-primary">SEM 17</td>
                    <td v-else>SEM 17</td>
                    <td v-if="this.checkIfWeekIsGreater(18)" class="table-primary">SEM 18</td>
                    <td v-else>SEM 18</td>
                    <td v-if="this.checkIfWeekIsGreater(19)" class="table-primary">SEM 19</td>
                    <td v-else>SEM 19</td>
                    <td v-if="this.checkIfWeekIsGreater(20)" class="table-primary">SEM 20</td>
                    <td v-else>SEM 20</td>
                    <td v-if="this.checkIfWeekIsGreater(21)" class="table-primary">SEM 21</td>
                    <td v-else>SEM 21</td>
                    <td v-if="this.checkIfWeekIsGreater(22)" class="table-primary">SEM 22</td>
                    <td v-else>SEM 22</td>
                    <td v-if="this.checkIfWeekIsGreater(23)" class="table-primary">SEM 23</td>
                    <td v-else>SEM 23</td>
                    <td v-if="this.checkIfWeekIsGreater(24)" class="table-primary">SEM 24</td>
                    <td v-else>SEM 24</td>
                    <td v-if="this.checkIfWeekIsGreater(25)" class="table-primary">SEM 25</td>
                    <td v-else>SEM 25</td>
                    <td v-if="this.checkIfWeekIsGreater(26)" class="table-primary">SEM 26</td>
                    <td v-else>SEM 26</td>
                    <td v-if="this.checkIfWeekIsGreater(27)" class="table-primary">SEM 27</td>
                    <td v-else>SEM 27</td>
                    <td v-if="this.checkIfWeekIsGreater(28)" class="table-primary">SEM 28</td>
                    <td v-else>SEM 28</td>
                    <td v-if="this.checkIfWeekIsGreater(29)" class="table-primary">SEM 29</td>
                    <td v-else>SEM 29</td>
                    <td v-if="this.checkIfWeekIsGreater(30)" class="table-primary">SEM 30</td>
                    <td v-else>SEM 30</td>
                    <td v-if="this.checkIfWeekIsGreater(31)" class="table-primary">SEM 31</td>
                    <td v-else>SEM 31</td>
                    <td v-if="this.checkIfWeekIsGreater(32)" class="table-primary">SEM 32</td>
                    <td v-else>SEM 32</td>
                    <td v-if="this.checkIfWeekIsGreater(33)" class="table-primary">SEM 33</td>
                    <td v-else>SEM 33</td>
                    <td v-if="this.checkIfWeekIsGreater(34)" class="table-primary">SEM 34</td>
                    <td v-else>SEM 34</td>
                    <td v-if="this.checkIfWeekIsGreater(35)" class="table-primary">SEM 35</td>
                    <td v-else>SEM 35</td>
                    <td v-if="this.checkIfWeekIsGreater(36)" class="table-primary">SEM 36</td>
                    <td v-else>SEM 36</td>
                    <td v-if="this.checkIfWeekIsGreater(37)" class="table-primary">SEM 37</td>
                    <td v-else>SEM 37</td>
                    <td v-if="this.checkIfWeekIsGreater(38)" class="table-primary">SEM 38</td>
                    <td v-else>SEM 38</td>
                    <td v-if="this.checkIfWeekIsGreater(39)" class="table-primary">SEM 39</td>
                    <td v-else>SEM 39</td>
                    <td v-if="this.checkIfWeekIsGreater(40)" class="table-primary">SEM 40</td>
                    <td v-else>SEM 40</td>
                    <td v-if="this.checkIfWeekIsGreater(41)" class="table-primary">SEM 41</td>
                    <td v-else>SEM 41</td>
                    <td v-if="this.checkIfWeekIsGreater(42)" class="table-primary">SEM 42</td>
                    <td v-else>SEM 42</td>
                    <td v-if="this.checkIfWeekIsGreater(43)" class="table-primary">SEM 43</td>
                    <td v-else>SEM 43</td>
                    <td v-if="this.checkIfWeekIsGreater(44)" class="table-primary">SEM 44</td>
                    <td v-else>SEM 44</td>
                    <td v-if="this.checkIfWeekIsGreater(45)" class="table-primary">SEM 45</td>
                    <td v-else>SEM 45</td>
                    <td v-if="this.checkIfWeekIsGreater(46)" class="table-primary">SEM 46</td>
                    <td v-else>SEM 46</td>
                    <td v-if="this.checkIfWeekIsGreater(47)" class="table-primary">SEM 47</td>
                    <td v-else>SEM 47</td>
                    <td v-if="this.checkIfWeekIsGreater(48)" class="table-primary">SEM 48</td>
                    <td v-else>SEM 48</td>
                    <td v-if="this.checkIfWeekIsGreater(49)" class="table-primary">SEM 49</td>
                    <td v-else>SEM 49</td>
                    <td v-if="this.checkIfWeekIsGreater(50)" class="table-primary">SEM 50</td>
                    <td v-else>SEM 50</td>
                    <td v-if="this.checkIfWeekIsGreater(51)" class="table-primary">SEM 51</td>
                    <td v-else>SEM 51</td>
                    <td v-if="this.checkIfWeekIsGreater(52)" class="table-primary">SEM 52</td>
                    <td v-else>SEM 52</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><input type="checkbox" :checked="selected.weeks.sem1" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem1" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem2" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem2" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem3" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem3" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem4" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem4" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem5" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem5" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem6" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem6" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem7" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem7" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem8" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem8" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem9" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem9" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem10" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem10" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem11" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem11" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem12" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem12" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem13" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem13" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem14" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem14" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem15" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem15" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem16" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem16" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem17" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem17" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem18" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem18" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem19" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem19" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem20" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem20" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem21" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem21" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem22" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem22" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem23" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem23" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem24" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem24" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem25" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem25" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem26" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem26" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem27" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem27" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem28" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem28" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem29" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem29" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem30" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem30" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem31" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem31" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem32" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem32" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem33" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem33" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem34" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem34" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem35" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem35" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem36" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem36" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem37" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem37" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem38" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem38" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem39" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem39" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem40" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem40" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem41" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem41" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem42" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem42" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem43" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem43" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem44" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem44" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem45" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem45" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem46" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem46" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem47" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem47" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem48" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem48" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem49" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem49" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem50" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem50" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem51" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem51" disabled></td>
                    <td><input type="checkbox" :checked="selected.weeks.sem52" @change="reCalculateTotalWeeks"
                        v-model="selected.weeks.sem52" disabled></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Total de semanas seleccionadas" label-for="total_weeks">
            <b-form-input id="total_weeks" v-model="selected.total_weeks" disabled />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card-code>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
  BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton, BFormSelect, BCardText
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import axiosIns from '../../libs/axios'

export default {
  components: {
    BCardCode,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
    BCardText,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      selected: {
        joining_type: null,
        budget_year: null,
        budget_code: null,
        payroll_type: null,
        company: null,
        position: null,
        department: null,
        area: null,
        section: null,
        ceco_code: null,
        ceco_type: null,
        subdivision: null,
        labor_type: null,
        status: null,
        organization_chart_id: null,
        budget_code_1: null,
        budget_code_1_sap_code: null,
        budget_code_1_num_doc: null,
        budget_code_1_full_name: null,
        budget_code_2: null,
        budget_code_2_sap_code: null,
        budget_code_2_num_doc: null,
        budget_code_2_full_name: null,
        sap_code: null,
        sap_doc_num: null,
        sap_full_name: null,
        sap_position: null,
        sap_ceco_code: null,
        sap_ceco_description: null,
        sap_area_description: null,
        sap_department: null,
        sap_area: null,
        sap_section: null,
        weeks: {},
        total_weeks: null,
        id: this.$route.params.id,
        application_period: null,
      },
      rules_list: [],
      rules: {
        budget_year: false,
        budget_code: false,
        payroll_type: false,
        company: false,
        position: false,
        department: false,
        area: false,
        section: false,
        ceco_code: false,
        ceco_type: false,
        subdivision: false,
        labor_type: false,
        status: false,
        organization_chart_id: false,
        sap_data: false,
        budget_code_1: false,
        budget_code_2: false,
        weeks: false,
        application_period: true,
      },
    }
  },
  methods: {
    getData() {
      const URL = '/nomina/get_single_request'
      const config = {
        method: 'get', url: URL, params: {
          request_id: parseInt(this.$route.params.id),
          app_user_id: this.getUserID(),
        }
      }

      this.selected.budget_code_1_sap_code = null
      this.selected.budget_code_1_num_doc = null
      this.selected.budget_code_1_full_name = null

      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.selected = response.data.response
            // To rebuild the selected model in the frontend
            this.reCalculateTotalWeeks()
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    printErrorModal(error) {
      this.$swal({
        title: 'Error!',
        text: error,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    reCalculateTotalWeeks() {
      let cont = 0
      for (const sem in this.selected.weeks) {
        if (this.selected.weeks[sem]) {
          cont = cont + 1
        }
      }
      this.selected.total_weeks = cont
    },
    getOrgNumber() {
      const URL = '/nomina/get_org_number'
      const config = {
        method: 'get', url: URL, params: {
          section: this.selected.section
        }
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.selected.organization_chart_id = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getSAPData() {
      const URL = '/nomina/get_sap_data'
      const config = {
        method: 'get', url: URL, params: {
          budget_code: this.selected.budget_code,
          app_user_id: this.getUserID(),
        }
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.selected.sap_code = response.data.response["sap_code"]
            this.selected.sap_doc_num = response.data.response["doc_num"]
            this.selected.sap_full_name = response.data.response["full_name"]
            this.selected.sap_position = response.data.response["position"]
            this.selected.sap_ceco_code = response.data.response["ceco_code"]
            this.selected.sap_ceco_description = response.data.response["ceco_description"]
            this.selected.sap_area_description = response.data.response["area_description"]
            this.selected.sap_department = response.data.response["department"]
            this.selected.sap_area = response.data.response["area"]
            this.selected.sap_section = response.data.response["section"]
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getSAPDataBudgetCode1() {
      const URL = '/nomina/get_sap_data'
      const config = {
        method: 'get', url: URL, params: {
          budget_code: this.selected.budget_code_1,
          app_user_id: this.getUserID(),
        }
      }

      this.selected.budget_code_1_sap_code = null
      this.selected.budget_code_1_num_doc = null
      this.selected.budget_code_1_full_name = null

      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.selected.budget_code_1_sap_code = response.data.response["sap_code"]
            this.selected.budget_code_1_num_doc = response.data.response["doc_num"]
            this.selected.budget_code_1_full_name = response.data.response["full_name"]
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getSAPDataBudgetCode2() {
      const URL = '/nomina/get_sap_data'
      const config = {
        method: 'get', url: URL, params: {
          budget_code: this.selected.budget_code_2,
          app_user_id: this.getUserID(),
        }
      }

      this.selected.budget_code_2_sap_code = null
      this.selected.budget_code_2_num_doc = null
      this.selected.budget_code_2_full_name = null

      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.selected.budget_code_2_sap_code = response.data.response["sap_code"]
            this.selected.budget_code_2_num_doc = response.data.response["doc_num"]
            this.selected.budget_code_2_full_name = response.data.response["full_name"]
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    getCecoType() {
      const URL = '/nomina/ceco_type'
      const config = {
        method: 'get', url: URL, params: {
          ceco_code: this.selected.ceco_code
        }
      }
      this.selected.ceco_type = null
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.selected.ceco_type = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    checkIfWeekIsGreater(single_week) {
      // Guard clause
      if (!this.selected.application_period) {
        return false
      }

      let isGreater = false
      let number = this.selected.application_period.match(/(\d+)/)[0];
      if (single_week >= number) {
        isGreater = true
      }
      return isGreater
    },
    getUserID() {
      const textUserData = localStorage.getItem('userData')
      const jsonUserData = JSON.parse(textUserData)
      const id = jsonUserData.id
      return id
    },
  },
  mounted() {
    this.getData()
  },
  watch: {
    'selected.budget_code'(newBudgetCode, oldBudgetCode) {
      this.getSAPData()
    },
    'selected.budget_code_1'(newBudgetCode1, oldBudgetCode1) {
      this.getSAPDataBudgetCode1()
    },
    'selected.budget_code_2'(newBudgetCode2, oldBudgetCode2) {
      this.getSAPDataBudgetCode2()
    },
    'selected.ceco_code'(newCecoType, oldCecoType) {
      this.getCecoType()
    }
  }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>